// API resources
import apiBanks from '@/api/modules/banks'

// Mutations
import {
  ADD_BANKS_LIST,
  ADD_BANK_CONTRACTS,
  RESET_MODULE
} from '@/store/mutation-types'

// Default state
const getDefaultState = () => {
  return {
    list: [],
    contracts: {}
  }
}
const state = getDefaultState()

// ----------------------------------------------------------------------

const actions = {
  fetch (context, cached = true) {
    if (cached && context.state.list.length !== 0) {
      return Promise.resolve()
    }

    return apiBanks.list()
      .then(data => context.commit(ADD_BANKS_LIST, data))
  },

  fetchContracts ({ commit, dispatch, state }, { id, cached = true }) {
    if (cached && state.contracts[id]) {
      return Promise.resolve(state.contracts[id])
    }
    return apiBanks.fetchContracts(id)
      .then(response => {
        commit(ADD_BANK_CONTRACTS, { id, contracts: response.data })
        return response.data
      })
  },

  resetState (context) {
    context.commit(RESET_MODULE)
  }
}

const mutations = {
  [ADD_BANKS_LIST] (state, data) {
    data = data.banks
    data.forEach(entry => { entry.id = String(entry.id) })
    state.list = data
  },

  [ADD_BANK_CONTRACTS] (state, { id, contracts }) {
    state.contracts = {
      ...state.contracts,
      [id]: contracts
    }
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  getById: ({ list }) => (id) => {
    return list.find(bank => bank.id === id)
  },

  getContractsByBank: ({ contracts }) => id => contracts[id],

  getByExternalID: ({ list }) => (externalId) => {
    return list.find(bank => bank.provider.bankId === externalId)
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations,
  getters
})
